import React, { Component } from "react";
import {withRouter} from "react-router-dom";
import "../../style/register.scss";
import "../../style/constant.scss";
import "../../style/userProfile.scss";
import "mapbox-gl/dist/mapbox-gl.css";
import Context from "../../tools/context";
import {getFields, userProfileFieldBase} from '../../tools/formFieldsDatabase'
import {getUserData, postUserData} from "../../tools/apitools";
import FormField from "../../components/formField/";
import AppButton from "../../components/AppButton";
import {clientT, t} from "../../tools/i18n";

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.adaptater = {
      contactEmail: 'email',
      zipcode: 'zipcode',
      question_1: `${Context.partner.sponsor}_custom_1`,
      question_2: `${Context.partner.sponsor}_custom_2`,
    }

    this.newKeys = ['name'];
    // get client profile fields 
    this.fields = getFields('clientProfile', userProfileFieldBase);
    Object.keys(this.fields).forEach(name => {
      const field = this.fields[name]
      field.forEach(f => {
        f.id = this.adaptater[f.id] || f.id;
        this.newKeys.push(f.id);
        if(f.type === 'select'){
          console.log(`transform f.values`)
          f.values = f.values.map((c, i) => (c.value? 
            {...c,key:`${c.value}_${(i+1)}` } :{
            key: `${f.id}_${(i+1)}`,
            label: c,
            value: i+1,
          }))
        }
      })      
    })
    if (Context.partner.clientProfile && Context.partner.clientProfile.optin) {
      this.newKeys = this.newKeys.concat(Context.partner.clientProfile.optin.map(f => f.id));
    }
    if (Context.partner.clientProfile && Context.partner.clientProfile.dropdownFields) {
      this.newKeys = this.newKeys.concat(Context.partner.clientProfile.dropdownFields.map(f => f.id));
    }

    this.state = {
      formData: {},
      //Error messages
      message: '',
      errorMessage: '',
      // question 2 should be hidden if zipcode = '13XXX'
      show_question_2: true,
      sellerStyle: Context.partner?.clientProfile?.sellerStyle ? true : false
    };
  }

  componentDidMount() {
    getUserData(this.newKeys, (result) => {
      // decode response
      const data = {};
      Object.entries(result).forEach(([k, v]) => {
        data[k] = v;
        // const element = document.getElementById(componentId);
        // if(element) {element.value = v}
      })
      data.lastname = data.name;
      this.setState({formData: data});

      if('zipcode' in result && result['zipcode'].startsWith(13)) {
        this.setState({show_question_2: false})
      }

    }, (e) => {
      this.setState({errorMessage: t('common.error')})
    })
  }

  handleChange = (e) => {
    // store all changes
    const formData = {
      ...this.state.formData, 
      [e.target.id]: e.target.value
    };

    if (e.target.id === 'zipcode') {
      if (e.target.value.startsWith(13)) {
        this.setState({show_question_2: false});
      } else {
        if (!this.state.show_question_2)
          this.setState({show_question_2: true})
      }
    }

    this.setState({formData});
  };


  /**
   * Get all the modified fields
   * build a body based on these values
   * then postData
   * @param {*} e: the event
   * @returns 
   */
  handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = this.state.formData;

    const now = new Date();
    now.setFullYear(now.getFullYear()-18);
    if ((now - new Date(formData.birthdate)) < 0) {
     this.setState({
       BirthdateError: 'Vous devez être majeur'
     })
      return;
    }

    let body = {}
    // encode response
    Object.entries(formData).forEach(([k, v]) => {
      if (k === 'lastname') k = 'name';
      body[k]= v;
    });
    
    // if the body is empty, do nothing
    if(Object.keys(body).length === 0) {
        this.postUserDataOk();
        return;
    }

    postUserData(body, (e) => this.postUserDataOk(e), (e) => this.postUserDataFail(e))
  }
  

  postUserDataOk(e) {
    window.scrollTo(0,0);
    this.setState({
      message: t('userProfile.confirmation'),
      errorMessage: '',
      // clear all posted changes
      formData: {}
    })
    this.props.history.push("/my-tickets"); //TODO redirect to my tickets if profile is full
  }

  postUserDataFail(e) {
    window.scrollTo(0,0);
    this.setState({
      message: '',
      errorMessage: t('userProfile.error'),
    });
  }

  buildForm() {
    return Object.keys(this.fields).map(k => {
      //console.log(this.fields[k])
      return (
      <div key={k}>
        {this.state.sellerStyle && <div className="formSubTitle">{k}</div>}
        {this.fields[k].map(f => this.buildField(f))}
      </div>)
    })
  }

  buildField(f) {
    // if zipcode == 13XXX, do not show 'question_2'
    if(f.id === this.adaptater['question_2'] && this.state.show_question_2 === false) {
      return null;
    }

    return (
      <FormField
        {...f}
        labelOptional = {!this.state.sellerStyle}
        key={f.id}
        optional={f.optional}
        disabled={f.disabled}
        value={this.state.formData[f.id]}
        errorMsg={f.errorMsgKey ? this.state[f.errorMsgKey] : null}
        handleChange={(e) => this.handleChange(e)}
        i18n
      />)
  }

  render() {
    const {sellerStyle} = this.state;
    return (
      <div className={`${sellerStyle && "informationsClient__Container"}`}>
          <div className="main informationsClient__mainWrapper">
          <p className={`informationsClient__mainHeading`}>{clientT('userProfile.title')}</p>
          <hr className="informationsClient__horizontalBar" />
          <p className={`informationsClient__desc`}>{Context.partner?.client?.profileTitle || clientT('userProfile.subtitle')}</p>
          <form onSubmit={this.handleFormSubmit} className={`${sellerStyle ? "formWrapper" : "informationsClient__form"}`}>
                  {/* state.errorMessage */}
              {this.state.errorMessage ?
                <div className="profile_error">
                  {this.state.errorMessage}
                </div>
                : null}
              {/* state.message */}
              {this.state.message ?
                <div className="profile_message">
                  {this.state.message}
                </div>
                : null}
                {this.buildForm()}
                {Context.partner?.clientProfile?.dropdownFields && 
                <>
                {sellerStyle && <div className="formSubTitle">{clientT('userProfile.questions')}</div>}
                { Context.partner.clientProfile.dropdownFields.map(f =>
                    <FormField
                      {...f}
                      labelOptional = {!sellerStyle}
                      customClass = {!sellerStyle}
                      type={f.type}
                      key={f.id}
                      optional={f.optional}
                      disabled={f.disabled}
                      value={this.state.formData[f.id]}
                      errorMsg={f.errorMsgKey ? this.state[f.errorMsgKey] : null}
                      handleChange={(e) => this.handleChange(e)}
                      i18n
                    />)
                  }
                  </>
                }
                {Context.partner.clientProfile && Context.partner.clientProfile.optin &&
                  Context.partner.clientProfile.optin.map(f =>
                    <FormField
                      {...f}
                      customClass = {!sellerStyle}
                      type={'checkbox'}
                      key={f.id}
                      optional={true}
                      disabled={f.disabled}
                      value={this.state.formData[f.id]}
                      errorMsg={f.errorMsgKey ? this.state[f.errorMsgKey] : null}
                      handleChange={(e) => this.handleChange(e)}
                      i18n
                    />)
                }
                <AppButton
                  className={`${sellerStyle ? "button button2 mt-2" : "informationsClient__submitForm"}`}
                  type="submit" event="Valider" client>
                  {t('common.validate')}
                </AppButton>
              </form>
            </div>
      </div>
    );
  }
}

export default withRouter(UserProfile);
